import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIUAFeatureTable from 'ui-addon-upgrades/featureTable/FeatureTable';
import FeatureTableColTag from '../../../components/feature-table/FeatureTableColTag';
import { useShowStarterCustomerPlatformUpsellCard } from '../../../hooks/upsell/useStarterUpsell';
import { SingleSkeletonLoader } from '../../components/SingleSkeletonLoader';
import { FeatureTableHeaderCellContent } from '../../components/feature-table/FeatureTableHeaderCellContent';
import { PriceByProductApiName } from '../../containers/PriceByProductApiName';
import { PurchaseMotionsByProductApiNameAndLocation } from '../../containers/PurchaseMotionsByProductApiNameAndLocation';
import { useBadges } from '../../hooks/badges/useBadges';
import { useFormattedFeatureTableBodyData } from '../../hooks/features/useFormattedFeatureTableBodyData';
import { createFeatureTableHeaderTrackingData } from '../../utils/trackingData';
import { jsx as _jsx } from "react/jsx-runtime";
export const DataHubFeatureTable = () => {
  var _badges$starterApiNam, _badges$operationsHu, _badges$operationsHu2;
  const {
    showStarterCustomerPlatformUpsellCard,
    upsellStarterApiName,
    loading
  } = useShowStarterCustomerPlatformUpsellCard();
  const starterApiNameForBadges = showStarterCustomerPlatformUpsellCard ? upsellStarterApiName : 'operations-hub-starter';
  const badgeApiNames = [starterApiNameForBadges, 'operations-hub-professional', 'operations-hub-enterprise'];
  const {
    badges
  } = useBadges({
    productApiNames: badgeApiNames,
    skipOverride: loading
  });
  const formattedFeatureTableBodyData = useFormattedFeatureTableBodyData({
    productApiNames: ['operations-hub-starter', 'operations-hub-professional', 'operations-hub-enterprise'],
    skuCategoryName: 'OPERATIONS_HUB_PRODUCTS'
  });
  if (formattedFeatureTableBodyData.error) {
    return null;
  }
  if (formattedFeatureTableBodyData.loading) {
    return /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 250,
      width: "100%"
    });
  }

  // If the fetch for data is successful and there are no features
  // don't render the table because the purchase motions are identical
  // to that of the merch card
  if (formattedFeatureTableBodyData.data.sectionData.all.features.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(UIUAFeatureTable, {
    canViewNewSeats: true,
    headerData: {
      'operations-hub-starter': {
        Content: /*#__PURE__*/_jsx(FeatureTableHeaderCellContent, {
          Badge: /*#__PURE__*/_jsx(FeatureTableColTag, {
            apiName: "operations-hub-starter",
            badgeName: badges === null || badges === void 0 || (_badges$starterApiNam = badges[starterApiNameForBadges]) === null || _badges$starterApiNam === void 0 ? void 0 : _badges$starterApiNam.badgeName
          }),
          ProductDisplayName: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "pricing-pages-ui.merchCardsV2.titleDisplay.starterCard"
          }),
          Price: /*#__PURE__*/_jsx(PriceByProductApiName, {
            productApiName: "operations-hub-starter"
          }),
          PurchaseMotion: /*#__PURE__*/_jsx(PurchaseMotionsByProductApiNameAndLocation, {
            productApiName: showStarterCustomerPlatformUpsellCard ? upsellStarterApiName : 'operations-hub-starter',
            location: "MERCH_CARD",
            displayCount: 1,
            trackingData: createFeatureTableHeaderTrackingData(showStarterCustomerPlatformUpsellCard ? upsellStarterApiName : 'operations-hub-starter', 'data')
          })
        })
      },
      'operations-hub-professional': {
        Content: /*#__PURE__*/_jsx(FeatureTableHeaderCellContent, {
          Badge: /*#__PURE__*/_jsx(FeatureTableColTag, {
            apiName: "operations-hub-professional",
            badgeName: badges === null || badges === void 0 || (_badges$operationsHu = badges['operations-hub-professional']) === null || _badges$operationsHu === void 0 ? void 0 : _badges$operationsHu.badgeName
          }),
          ProductDisplayName: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "pricing-pages-ui.merchCardsV2.titleDisplay.professionalCard"
          }),
          Price: /*#__PURE__*/_jsx(PriceByProductApiName, {
            productApiName: "operations-hub-professional"
          }),
          PurchaseMotion: /*#__PURE__*/_jsx(PurchaseMotionsByProductApiNameAndLocation, {
            productApiName: "operations-hub-professional",
            location: "MERCH_CARD",
            displayCount: 1,
            trackingData: createFeatureTableHeaderTrackingData('operations-hub-professional', 'data')
          })
        })
      },
      'operations-hub-enterprise': {
        Content: /*#__PURE__*/_jsx(FeatureTableHeaderCellContent, {
          Badge: /*#__PURE__*/_jsx(FeatureTableColTag, {
            apiName: "operations-hub-enterprise",
            badgeName: badges === null || badges === void 0 || (_badges$operationsHu2 = badges['operations-hub-enterprise']) === null || _badges$operationsHu2 === void 0 ? void 0 : _badges$operationsHu2.badgeName
          }),
          ProductDisplayName: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "pricing-pages-ui.merchCardsV2.titleDisplay.enterpriseCard"
          }),
          Price: /*#__PURE__*/_jsx(PriceByProductApiName, {
            productApiName: "operations-hub-enterprise"
          }),
          PurchaseMotion: /*#__PURE__*/_jsx(PurchaseMotionsByProductApiNameAndLocation, {
            productApiName: "operations-hub-enterprise",
            location: "MERCH_CARD",
            displayCount: 1,
            trackingData: createFeatureTableHeaderTrackingData('operations-hub-enterprise', 'data')
          })
        })
      }
    },
    bodyData: formattedFeatureTableBodyData.data,
    isInbound25PricingPage: true
  });
};